import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
export default makeStyles()((theme) => ({
    extensivAccordion: {
        background: '#F5F5F5',
        '& .MuiAccordionSummary-root': {
            minHeight: 41,
            color: theme.palette.common.black,
            '& .MuiAccordionSummary-content': {
                margin: '10px 0',
            }
        },
        '& .MuiAccordionDetails-root': {
            color: alpha(theme.palette.common.black, 0.87),
        },
    },
}));
//# sourceMappingURL=styles.js.map